export default {
  // Components with locals that were deleted below

  'paymentAction.modalTitle.delete': 'Delete Payment',
  'paymentAction.modalTitle.deletetransactions': 'Delete Transaction',
  'paymentAction.modalTitle.disable': 'Disable Payment',
  'paymentAction.modalBody.delete': 'payment(s) will be deleted and will be permanently removed.',
  'paymentAction.modalBody.deletetransactions':
    'Transaction will be deleted and will be permanently removed.',
  'paymentAction.modalBody.disable': 'payment(s) will be disabled.',
  'paymentAction.modalBody.proceed': 'Do you want to proceed?',
  // Approve
  'paymentAction.modalTitle.approve': 'Approve Payment',
  'paymentAction.modalTitle.approvetransactions': 'Approve Transaction',
  'paymentAction.modalBody.approve': 'payment(s) will be approved.',
  'paymentAction.modalBody.approvetransactions': 'Transaction will be approved.',
  'paymentAction.leaveModalBody': 'You have unsaved changes. Approve payment anyways?',
  // Reject
  'paymentAction.modalTitle.reject': 'Reject Payment',
  'paymentAction.modalTitle.rejecttransactions': 'Reject Transaction',
  'paymentAction.modalBody.reject': 'payment(s) will be rejected.',
  'paymentAction.modalBody.rejecttransactions': 'Transaction will be rejected.',
  'createPaymentTemplates.continue': 'Template saved',
  'createPaymentTemplates.error': 'Save template failed',
  'createPaymentTemplates.templateName.error': 'Template name already used',
  'createPaymentTemplates.sameDayValidation': 'Same day settlement. Additional fee may apply.',
  'createPaymentTemplates.beneficiary': 'Name',
  'createPaymentTemplates.beneficiaryAccountNumber': 'Account Number',
  'createPaymentTemplates.beneficiaryBankRoutingNumber': 'Bank Code / Number',
  'createPaymentTemplates.beneficiaryId': 'Id',
  'createPaymentTemplates.id': 'Id',
  'createPaymentTemplates.noPaymentTypes': 'There are no payment types set up for you',
  'createPaymentTemplates.transactionType': 'Credit / Debit',
  'createPaymentTemplates.modal.modifyTemplate': 'Modify Template',
  'createPaymentTemplates.modal.modifyTemplate.body':
    'You are about to make freeform changes to the template.',
  'createPaymentTemplates.modal.modifyPayment': 'Modify Payment',
  'createPaymentTemplates.modal.modifyPayment.body':
    'You are about to make freeform changes to the payment.',
  'paymentTemplateItemView.accountNumber': 'Account Number',
  'paymentTemplateItemView.accountType': 'Account Type',
  'paymentTemplateItemView.amount': 'Amount',
  'paymentTemplateItemView.benid': 'Id',
  'paymentTemplateItemView.creditDebit': 'Credit/Debit',
  'paymentTemplateItemView.entry': 'Entry #',
  'paymentTemplateItemView.error': 'Error Retrieving Information.',
  'paymentTemplateItemView.lastActivationDate': 'Last Activation Date',
  'paymentTemplateItemView.name': 'Name',
  'paymentTemplateItemView.routingNumber': 'Bank Code / Number',
  'paymentTemplateItemView.status': 'Status',
  'paymentTemplateItemView.deletePaymentTemplate': 'Delete Payment Template',
  'paymentTemplateItemView.deleteTransferTemplateContent':
    'Template will be deleted and will be permanently removed.',

  // ACH Reversal
  'achReversal.submitReversal': 'Submit Reversal',
  'achReversal.approveReversal': 'Approve Reversal',
  'achReversal.rejectReversal': 'Reject Reversal',
  'achReversal.initiate.successWithDualApprove': 'Reversal has been submitted for approval.',
  'achReversal.initiate.successWithDualApproveMultiple':
    '<%= count %> Reversals have been submitted for approval.',
  'achReversal.validation.invalidTransactionDate': 'Invalid transaction date',
  'achReversal.initiate.success': 'Reversal has been initiated.',
  'achReversal.initiate.successMultiple': '<%= count %> Reversals have been initiated.',
  'achReversal.reason.DUPLICATE': 'Duplicate',
  'achReversal.reason.INCORRECT_ACCOUNT_NUMBER': 'Incorrect account number',
  'achReversal.reason.INCORRECT_AMOUNT': 'Incorrect amount',
  'achReversal.reason.INCORRECT_CREDIT_DATE':
    'Incorrect credit date - processed later than intended',
  'achReversal.reason.INCORRECT_DEBIT_DATE':
    'Incorrect debit date - processed earlier than intended',
  'achReversal.confirmation.NOT_ELIGIBLE_FOR_SAME_DAY':
    'Transactions that exceed $100 000.00 are not eligible for same day reversal. \nDo you want to reverse the eligible transactions?',
  'achReversal.confirmation.ELIGIBLE_FOR_NEXT_BUS_DAY':
    'Transactions that exceed $100 000.00 are not eligible for same day reversal and will be processed next business day. \nDo you want to proceed?',
  'achReversal.warning.selectTransactions':
    'Please select at least one transaction to send reversal.',

  // TAX
  'tax.form.federal': 'Federal',
  'tax.form.state': 'State',
  'tax.headings.initiationAndApprovalInformation': 'Initiation & Approval Information',
  'tax.headings.originatorInformation': 'Originator Information',
  'tax.headings.paymentDetails': 'Payment Details',
  'tax.headings.amountAndType': 'Amount & Type',
  'tax.headings.paymentInformation': 'Payment Information',
  'tax.headings.taxDetails': 'Tax Details',
  'tax.headings.taxInformation': 'Tax Information',
  'tax.labels.endDate': 'End Date',
  'tax.labels.firstTaxAmount': 'First Tax Amount',
  'tax.labels.firstTaxAmountCode': 'First Tax Amount Code',
  'tax.labels.formType': 'Form Type',
  'tax.labels.medicareAmount': 'Medicare Amount',
  'tax.labels.nineDigitEin': '9 Digit EIN',
  'tax.labels.secondTaxAmount': 'Second Tax Amount',
  'tax.labels.secondTaxAmountCode': 'Second Tax Amount Code',
  'tax.labels.socialSecurityAmount': 'Social Security Amount',
  'tax.labels.tax': 'Tax',
  'tax.labels.taxPeriod': 'Tax Period',
  'tax.labels.thirdTaxAmount': 'Third Tax Amount',
  'tax.labels.thirdTaxAmountCode': 'Third Tax Amount Code',
  'tax.labels.witholdingAmount': 'Withholding Amount',
  'tax.messages.paymentInformationMessage': 'Select Tax Information to add Payment Information',
  'tax.send.confirm.action': 'Send',
  'tax.send.confirm.title': 'You are about to send this tax payment. Do you want to proceed?',
  'tax.send.presentTenseAction': 'Sending',
  'tax.submit.confirm.action': 'Submit',
  'tax.submit.confirm.title': 'You are about to submit this tax payment. Do you want to proceed?',
  'tax.submit.presentTenseAction': 'Submitting',
  'tax.totalAmountCannotBeZero': 'Total amount cannot be $0.00',

  // Import Review
  'importreview.earliest.warning': 'Earliest available payment date is',
  'importreview.latest.warning': 'Latest available payment date is',

  // Modify Transactions
  'achtxngrid.modify.success': 'Transaction(s) Updated',
  'achtxngrid.modify.error': 'Failed to update Transaction(s)',

  // Transaction Grid
  'achtxngrid.modal.status':
    '<%= length %> transaction(s) will be changed to status: <%= status %>',
  'achtxngrid.modal.delete': '<%= length %> transaction(s) will be deleted',
  'achtxngrid.modal.zero':
    '<%= length %> transaction(s) amount will be changed to Zero and the status will be set to Frozen.',

  'achtxngrid.zeroAlert': 'Zero amount transactions cannot be activated.',
  // Recurring
  'recurring.alert.set':
    'Clicking Initiate will send a payment outside of the recurring schedule.',

  // column filters
  'paymentTemplates.columnFilters.nameDisplay.status': 'Status',
  'paymentTemplates.columnFilters.nameDisplay.paymentCategory': 'Payment Category',

  'ach.print.paymentInformation': 'PAYMENT INFORMATION',
  'ach.print.transactionDetails': 'TRANSACTION DETAILS',
  'ach.print.originatorInformation': 'ORIGINATOR INFORMATION',

  // Errors
  'ach.paymentType.error': 'Error loading <%= code %> payment type!',

  'ach.leaving': 'Leaving...',
  'ach.adding': 'Adding...',
  'ach.sending': 'Sending...',

  'ach.collections': 'Collections',
  'ach.sendCollection': 'Send Collection',

  // titles
  'ach.title.payment.create': 'Create ACH <%- paymentType %>',
  'ach.title.payment.modify': 'Modify ACH <%- paymentType %>',
  'ach.title.payment.reverse': 'Reverse ACH <%- paymentType %>',
  'ach.title.payment.modify-reversal': 'Modify ACH Reversal',
  'ach.title.payment.view': 'View ACH <%- paymentType %>',
  'ach.title.template.create': 'Create ACH Template',
  'ach.title.template.template-copy': 'Copy ACH Template',
  'ach.title.template.template-modify': 'Modify ACH Template',
  'ach.title.template.template-view': 'View ACH Template'
};
